import { z } from 'zod/v4'

export const localeSchema = z.object({
  currency: z.object({
    name: z.string(),
    name_plural: z.string(),
    symbol: z.string(),
    code: z.string(),
  }),
  date: z.object({
    format: z.string(),
    format_long: z.string(),
    format_short: z.string(),
    format_time: z.string(),
  }),
  number: z.object({
    decimal_separator: z.string(),
    thousand_separator: z.string(),
    decimal_places: z.number(),
  }),
  property: z.object({
    building_types: z.array(z.string()),
    room_types: z.array(z.string()),
    min_year: z.number(),
    min_size: z.number(),
    max_size: z.number(),
    min_rooms: z.number(),
    max_rooms: z.number(),
    min_price: z.number(),
    max_price: z.number(),
  }),
  users: z.object({
    roles: z.array(z.string()),
  }),
  realtor: z.object({
    realtor_role: z.string(),
    revenue_share: z.number(),
  }),
})

export type Locale = z.infer<typeof localeSchema>
